module.exports = __webpack_public_path__ + "static/media/payment-status-done-icon.04c9d961.svg";